/**
 * Evora Brand Color Palette
 *
 * This file contains the official Evora color constants used across all themes.
 * Colors are organized by their usage context.
 */

// Primary Brand Colors
export const EVORA_PURPLE = '#6B72AE';
export const DARK_BLUE = '#1B223A';
export const STORM_BLUE = '#38546D';
export const SKY_BLUE = '#C8DBEE';
export const DARK_OLIVE = '#ABBB7D';
export const LIGHT_OLIVE = '#D1D7B0';

// Chart accents
export const WATER_BLUE = '#0288D1';
export const WATER_BLUE_DARK = '#4FC3F7'; // lighter tint so it reads on Dark Blue backgrounds

// Semantic Colors
export const ERROR_MAIN = '#f44336';
export const ERROR_DARK = '#d32f2f';
export const WARNING_LIGHT = '#FF9800';
export const WARNING_MAIN = '#ed6c02';
export const WARNING_DARK = '#e65100';

// Grouped exports for easier imports
export const EVORA_COLORS = {
  // Brand
  evoraPurple: EVORA_PURPLE,
  darkBlue: DARK_BLUE,
  stormBlue: STORM_BLUE,
  skyBlue: SKY_BLUE,
  darkOlive: DARK_OLIVE,
  lightOlive: LIGHT_OLIVE,
  waterBlue: WATER_BLUE,
  waterBlueDark: WATER_BLUE_DARK,

  // Semantic
  error: {
    main: ERROR_MAIN,
    dark: ERROR_DARK,
  },
  warning: {
    light: WARNING_LIGHT,
    main: WARNING_MAIN,
    dark: WARNING_DARK,
  },
};

// Theme-specific color configurations
export const TENANT_LIGHT_COLORS = {
  primary: EVORA_PURPLE,
  secondary: DARK_OLIVE,
  background: {
    default: '#F2F3F4',
    paper: '#FFFFFF',
    nav: '#FAFAFA',
    navHover: 'rgba(107, 114, 174, 0.08)',  // EVORA_PURPLE at 8%
    navActive: 'rgba(107, 114, 174, 0.12)', // EVORA_PURPLE at 12%
  },
  appBar: {
    background: DARK_BLUE,
    text: SKY_BLUE,
  },
};

export const TENANT_DARK_COLORS = {
  primary: '#FFFFFF', // White for nav icons - high visibility on dark backgrounds
  secondary: SKY_BLUE, // Sky blue for selected/active state
  text: {
    primary: '#FFFFFF',
    secondary: 'rgba(255, 255, 255, 0.7)',
  },
  background: {
    default: DARK_BLUE,
    paper: '#252D48',
    nav: '#1E2640',
    navHover: 'rgba(255, 255, 255, 0.08)',  // White at 8%
    navActive: 'rgba(200, 219, 238, 0.15)', // Sky blue at 15%
  },
  appBar: {
    background: LIGHT_OLIVE, // On-brand light olive (#D1D7B0)
    text: STORM_BLUE, // Storm blue text/icons for contrast (#38546D)
  },
};

export const ADMIN_LIGHT_COLORS = {
  primary: STORM_BLUE,
  secondary: EVORA_PURPLE,
  background: {
    default: '#F0F4F7',
    paper: '#FFFFFF',
    nav: '#E8EEF3',
    navHover: 'rgba(56, 84, 109, 0.08)',   // STORM_BLUE at 8%
    navActive: 'rgba(56, 84, 109, 0.12)',  // STORM_BLUE at 12%
  },
  appBar: {
    background: STORM_BLUE,
    text: '#FFFFFF',
  },
};

export const ADMIN_DARK_COLORS = {
  primary: '#FFFFFF', // White for nav icons - high visibility on dark backgrounds
  secondary: SKY_BLUE, // Sky blue for selected/active state
  text: {
    primary: '#FFFFFF',
    secondary: 'rgba(255, 255, 255, 0.7)',
  },
  background: {
    default: '#0D1321',
    paper: '#1A2332',
    nav: '#141C28',
    navHover: 'rgba(255, 255, 255, 0.08)',  // White at 8%
    navActive: 'rgba(200, 219, 238, 0.15)', // Sky blue at 15%
  },
  appBar: {
    background: '#1A2332',
    text: '#FFFFFF',
  },
};

export default EVORA_COLORS;
